import {Icon, clx} from '@hm/fundamental'
import {mdiFilePdfBox, mdiFile, mdiPlayBoxOutline} from '@mdi/js'

import type {AttachedDocumentFile} from '../../types'

import {DeleteDocumentButton} from './DeleteDocumentButton'
import {DownloadDocumentOverlay} from './DownloadDocumentOverlay'

interface AttachedDocumentFileViewProps {
  attachedDocumentFile: AttachedDocumentFile
  isDisabled?: boolean
  isDownloadEnabled?: boolean
  shouldShowFileName?: boolean
  iconSize?: number
  className?: string
  onDocumentDelete?: () => void
}

const CONTENT_TYPE_ICON_MAP = {
  'application/pdf': mdiFilePdfBox,
  'application/vnd.ms-excel': mdiFile,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': mdiFile,
  'video/mp4': mdiPlayBoxOutline,
  'video/3gp': mdiPlayBoxOutline,
  'video/mov': mdiPlayBoxOutline
}

export const AttachedDocumentFileView: React.FC<AttachedDocumentFileViewProps> = ({
  attachedDocumentFile,
  isDisabled = false,
  isDownloadEnabled = true,
  shouldShowFileName = true,
  iconSize,
  className,
  onDocumentDelete
}) => {
  const fileContent = attachedDocumentFile.isImage ? (
    <img
      src={attachedDocumentFile.preview}
      alt={attachedDocumentFile.name}
      className={clx('w-full', className)}
      data-cy={`attached_image_${attachedDocumentFile.name}`}
    />
  ) : (
    <div className="flex flex-col pt-3">
      {shouldShowFileName && attachedDocumentFile.name}
      <Icon
        path={CONTENT_TYPE_ICON_MAP[attachedDocumentFile.contentType] ?? mdiFile}
        customSize={iconSize ?? 3}
        data-cy={`attached_document_${attachedDocumentFile.name}`}
      />
    </div>
  )

  return (
    <div className="relative">
      {onDocumentDelete && (
        <DeleteDocumentButton isDisabled={isDisabled} onDocumentDelete={onDocumentDelete} />
      )}
      <div>
        {isDownloadEnabled && (
          <DownloadDocumentOverlay attachedDocumentFile={attachedDocumentFile} />
        )}
        {fileContent}
      </div>
    </div>
  )
}
